export function mapChartApiToStacked(response) {
    return response.stackedData.map((d) => ({
        label: d.label,
        actual: d.actual,
        target: d.target,
        targetAchieved: d.targetAchieved,
        targetPartiallyAchieved: d.targetPartiallyAchieved,
        targetNotAchieved: d.targetNotAchieved,
        remainder: d.remainder,
        periodStart: d.periodStart,
        periodEnd: d.periodEnd,
    }));
}
export function mapChartApiToDay(response) {
    return response.dayData.map((d) => ({
        weekday: d.weekday,
        value: d.value,
        date: d.date,
    }));
}
export function mapLeaderboardApiToRows(response) {
    return response.rows.map((r) => ({
        rank: r.rank,
        agentId: r.agentId,
        agent: r.agentName,
        objectsSent: r.objectsSent,
        objectsWon: r.objectsWon,
        revenue: r.revenue,
    }));
}
export const defaultDashboardKpiFilter = {
    startDate: `${new Date().getFullYear()}-01-01`,
    endDate: new Date().toISOString().split("T")[0],
};
